import { DirectiveOptions } from 'vue';

export default {
    update: (el, binding) => {
        el.style.visibility = !!binding.value ? 'hidden' : ''
    }
} as DirectiveOptions